import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import * as React from "react";
import { DefaultProps } from "../../LayoutWrapper";
import { MessagesList } from "./messagesList";

interface PurchasesState {
    activeTab: string;
}

interface Props extends DefaultProps {
    playerId: string;
}

export class PlayerMessages extends React.Component<Props, PurchasesState> {

    constructor(props) {
        super(props);

        this.state = {
            activeTab: "received"
        };
    }

    handleChange(newValue) {
        this.setState({
            activeTab: newValue
        })
    }

    render() {
        return <TabContext value={this.state.activeTab}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <TabList onChange={(_event, newValue) => this.handleChange(newValue)}>
                    <Tab label="Received messages" value="received" />
                    <Tab label="Sent messages" value="sent" />
                </TabList>
            </Box>

            <TabPanel value="received" style={{ padding: "24px 0" }}>
                <MessagesList {...this.props} type="received"/>
            </TabPanel>
            <TabPanel value="sent" style={{ padding: "24px 0" }}>
                <MessagesList {...this.props} type="sent"/>
            </TabPanel>
        </TabContext>
    }
}
